import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../utils/api';
import { Box, Typography, TextField, Button, Paper, Alert } from '@mui/material';
import logo from '../assets/logo.png';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, adminUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }

    try {
      const response = await api.post('/admin/login', { email, password });
      const { id, role, accessToken, refreshToken, name } = response.data;
      console.log('API Response:', { id, role, accessToken, refreshToken, name });

      const userData = {
        id: id || 'admin',
        role: role || 'admin',
        accessToken,
        refreshToken: refreshToken || '',
        name: name || 'Admin User',
      };

      const success = login(userData);
      if (success) {
        setError('');
        console.log('Login successful, navigating to /admin/dashboard');
        navigate('/admin/dashboard', { replace: true });
      } else {
        setError('Login failed due to invalid user data.');
        console.error('Login function returned false with data:', userData);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Login failed. Please check your credentials.';
      setError(errorMessage);
      console.error('Admin login error:', err.response?.data || err.message);
    }
  };

  const handleKeyPress = (e) => e.key === 'Enter' && handleLogin();

  useEffect(() => {
    if (adminUser) {
      console.log('Admin already logged in, redirecting to /admin/dashboard');
      navigate('/admin/dashboard', { replace: true });
    }
  }, [adminUser, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#e0f7fa' }}>
      <Paper elevation={6} sx={{ p: 4, borderRadius: 3, width: { xs: '90%', sm: 400 } }}>
        <Box display="flex" justifyContent="center" mb={3}>
          <img src={logo} alt="TureMedicine" style={{ height: 50 }} />
        </Box>
        <Typography variant="h5" align="center" gutterBottom>Admin Login</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          label="Email"
          type="email"
          variant="outlined"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
          sx={{ mb: 2 }}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          sx={{ mb: 3 }}
        />
        <Button
          variant="contained"
          fullWidth
          onClick={handleLogin}
          sx={{ background: '#1976d2', '&:hover': { background: '#115293' } }}
        >
          Login
        </Button>
      </Paper>
    </Box>
  );
};

export default AdminLogin;